import { GET_OPD_NOTIFICATIONS } from './actionTypes';

const notificationState = {
  hasNotification: false
};

export default function reducer(state = notificationState, action) {
  const { payload, type } = action;

  switch (type) {
    case `${GET_OPD_NOTIFICATIONS}_SUCCESS`:
      return {
        ...state,
        ...payload,
        hasNotification: Object.keys(payload).length !== 0
      };

    default:
      return state;
  }
}
